import { URLs } from "@/constants";
import type { IAnalyticsData, IApiRequest, IApp } from "@/types";
import { apiURL, flatten, sendRequest, sendRequestWithAnalyzeAllPolling } from "@/utils";

namespace GoogleSearchConsoleAction {
  export async function getAnalyticsData(
    userId: string,
    customerId: string,
    accountId: string,
    payload: IApiRequest.GoogleSearchConsoleAnalyticsPage & IApiRequest.Pagination
  ): Promise<IApp.IApiResponse<{ data: Array<IAnalyticsData.IGoogleSearchConsolePage> }>>;

  export function getAnalyticsData(
    userId: string,
    customerId: string,
    accountId: string,
    payload: IApiRequest.GoogleSearchConsoleAnalyticsQuery & IApiRequest.Pagination
  ): Promise<IApp.IApiResponse<{ data: Array<IAnalyticsData.IGoogleSearchConsoleQuery> }>>;

  export function getAnalyticsData(
    userId: string,
    customerId: string,
    accountId: string,
    payload: IApiRequest.GoogleSearchConsoleAnalyticsImpressionPositionClick &
      IApiRequest.Pagination
  ): Promise<
    IApp.IApiResponse<{ data: IAnalyticsData.IGoogleSearchConsoleAnalyticsImpressionPositionClick }>
  >;

  export function getAnalyticsData(
    userId: string,
    customerId: string,
    accountId: string,
    payload: IApiRequest.GoogleSearchConsoleAnalyticsDeviceTotal & IApiRequest.Pagination
  ): Promise<IApp.IApiResponse<{ data: Array<IAnalyticsData.IGoogleSearchConsoleDeviceTotal> }>>;

  export async function getAnalyticsData(
    userId: string,
    customerId: string,
    accountId: string,
    payload:
      | (IApiRequest.GoogleSearchConsoleAnalyticsPage & IApiRequest.Pagination)
      | (IApiRequest.GoogleSearchConsoleAnalyticsQuery & IApiRequest.Pagination)
      | (IApiRequest.GoogleSearchConsoleAnalyticsImpressionPositionClick & IApiRequest.Pagination)
      | (IApiRequest.GoogleSearchConsoleAnalyticsDeviceTotal & IApiRequest.Pagination)
  ): Promise<
    | IApp.IApiResponse<{ data: Array<IAnalyticsData.IGoogleSearchConsolePage> }>
    | IApp.IApiResponse<{ data: Array<IAnalyticsData.IGoogleSearchConsoleQuery> }>
    | IApp.IApiResponse<{
        data: IAnalyticsData.IGoogleSearchConsoleAnalyticsImpressionPositionClick;
      }>
    | IApp.IApiResponse<{
        data: Array<IAnalyticsData.IGoogleSearchConsoleDeviceTotal>;
      }>
  > {
    return await sendRequest<{ data: any }>({
      url: apiURL(URLs.API_GOOGLE_SEARCH_CONSOLE_ANALYTICS(userId, customerId, accountId)),
      method: "GET",
      params: flatten(payload)
    });
  }

  export const getAllAnalyticsData = async (
    userId: string,
    customerId: string,
    accountId: string,
    payload: {
      monthRange: { start: string; end: string };
      comparedMonthRange: { start: string; end: string };
    }
  ) => {
    return await sendRequestWithAnalyzeAllPolling<{
      query: Array<IAnalyticsData.IGoogleSearchConsoleQuery> | null;
      page: Array<IAnalyticsData.IGoogleSearchConsolePage> | null;
      "device-total": Array<IAnalyticsData.IGoogleSearchConsoleDeviceTotal> | null;
      "impression-position-click": IAnalyticsData.IGoogleSearchConsoleAnalyticsImpressionPositionClick | null;
      "impression-position-click-compared": IAnalyticsData.IGoogleSearchConsoleAnalyticsImpressionPositionClick | null;
    }>({
      url: apiURL(URLs.API_GOOGLE_SEARCH_CONSOLE_ANALYZE_ALL(userId, customerId, accountId)),
      method: "GET",
      params: flatten(payload)
    });
  };

  export const getSiteList = async (userId: string, customerId: string, accountId: string) => {
    return await sendRequest<{ siteUrls: string[] }>({
      url: apiURL(URLs.API_GOOGLE_SEARCH_CONSOLE_SITE_LIST(userId, customerId, accountId)),
      method: "GET"
    });
  };
}

export default GoogleSearchConsoleAction;
